import React from 'react';
import IconTriangle from './IconTriangle';

const IconRestriction = (props) => <IconTriangle {...props} />;

IconRestriction.defaultProps = {
    fill: '#05BDFF',
};

IconRestriction.displayName = 'Restricted Zone';

export default IconRestriction;
